import { Link, useLocation, useNavigate } from "react-router-dom";
import { logout } from "../../auth/authSlice";
import { useDispatch, useSelector } from "react-redux";
import userStore from "../../zustand/userStore";

import "./styles/style.css";
import { useEffect } from "react";
import { createEligibility, getEligibilityCategories } from "./redux/thunk";
import { clearError, setFormData, setskillProgramIds } from "./redux/slice";
import { loginUserThunk } from "../../auth/authThunk";

function Eligibility() {
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userData = userStore((state) => state.user);
  const { user } = useSelector((state) => state.authSlice);

  const { categories, formData, error } = useSelector(
    (store) => store.eligibility
  );

  const logOut = () => {
    dispatch(logout());
    navigate("/home");
  };

  useEffect(() => {
    !user && dispatch(loginUserThunk());
    dispatch(getEligibilityCategories());
  }, [dispatch]);

  useEffect(() => {
    if (user) {
      dispatch(
        setFormData({ name: "schoolName", value: user.school_name || "" })
      );
      dispatch(setFormData({ name: "email", value: user.email || "" }));
      dispatch(
        setFormData({ name: "mobile", value: user.contact_number || "" })
      );
    }
  }, [user, dispatch]);
  // reusable handler
  const handleChange = (e) => {
    const { name, value } = e.target;
    dispatch(setFormData({ name, value }));
  };

  const handleSumbitForm = async (e) => {
    e.preventDefault();
    try {
      const body = {
        ...formData,
        noOfStudents: formData.noStudents,
        admin_id: user.admin_id,
        user_id: user.id,
        otherData: JSON.stringify(formData.skillProgramIds),
        skillDevData:
          formData.anySkillProgram === "yes"
            ? JSON.stringify({
                isData: "yes",
                skillDevData: formData.skillProgramDetails,
              })
            : "no",
      };
      await dispatch(createEligibility(body));
    } catch (err) {
      console.log(err, "error message");

      return console.log(err);
    }
  };
  useEffect(() => {
    if (error) {
      window.alert(error.message);
      dispatch(clearError());
    }
  }, [error, dispatch]);

  return (
    <>
      <nav
        className="navbar navbar-expand-lg p-0"
        style={{
          background: "linear-gradient(to right, #7B2FF7 50%, #F40076 100%)",
          fontSize: "0.85rem",
          boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
        }}
      >
        <div
          className="container-fluid px-0 mx-auto"
          style={{ maxWidth: "100%" }}
        >
          {" "}
          <button
            className="navbar-toggler mx-2"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ps-4 w-100 d-flex gap-3 justify-content-start">
              <li
                className={`nav-item ${
                  ["/dashboard"].includes(pathname) ? "active" : ""
                }`}
              >
                <Link to="/dashboard" className="nav-link text-white">
                  <i
                    className="fa fa-home"
                    style={{ pointerEvents: "none" }}
                  ></i>{" "}
                  Home
                </Link>
              </li>
            </ul>
          </div>
          <div className="d-flex align-items-center justify-content-end gap-3">
            <div className="dropdown me-3">
              <button
                className="btn btn-light dropdown-toggle d-flex align-items-center"
                type="button"
                id="userDropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="fa fa-user me-2"></i>
                {userData.name}
              </button>
              <ul
                className="dropdown-menu dropdown-menu-end"
                aria-labelledby="userDropdown"
              >
                <li>
                  <span className="dropdown-item">Profile</span>
                </li>
                {/* <li>
                  <span className="dropdown-item d-flex justify-content-between align-items-center">
                    Settings
                    <span
                      style={{
                        backgroundColor: "#ff4444",
                        borderRadius: "10px",
                        padding: "2px 8px",
                        color: "white",
                        fontSize: "12px",
                      }}
                    >
                      50%
                    </span>
                  </span>
                </li>
                <li>
                  <span className="dropdown-item">Help</span>
                </li> */}
                <li>
                  <span className="dropdown-item" onClick={logOut}>
                    <i className="fa fa-sign-out me-2"></i>
                    Log Out
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <style jsx>{`
          .nav-item.active .nav-link {
            font-weight: 600;
            background-color: #f3e5f5;
            color: #7b2ff7 !important;
            border-radius: 4px;
          }
          .active-indicator {
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            width: 0;
            height: 3px;
            background: #bbdefb; /* Light blue indicator */
            transition: width 0.3s ease;
          }
          .nav-item.active .active-indicator {
            width: 80%;
          }
          .nav-link {
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;
            transition: all 0.3s ease;
            border-radius: 4px;
            font-size: 14px;
          }
          .hover-effect:hover {
            background-color: rgba(255, 255, 255, 0.15);
            transform: translateY(-2px);
          }
          .nav-item.active .hover-effect:hover {
            background-color: rgba(255, 255, 255, 0.25);
          }
          .navbar-nav {
            gap: 0.5rem;
          }
        `}</style>
      </nav>

      {/* FORM */}
      <div className="e-shadow-box">
        <h5>Check Eligibility form for Skill Development</h5>
        <form onSubmit={handleSumbitForm}>
          <fieldset>
            <div className="e-centered mt-2">
              <div className="mb-3">
                <label className="e-cuctsom-label-field">School Name</label>
                <input
                  className="e-custom-input-field"
                  type="text"
                  name="schoolName"
                  value={formData.schoolName}
                  onChange={handleChange}
                />
              </div>

              <div className="mb-3">
                <label className="e-cuctsom-label-field">E Mail</label>
                <input
                  className="e-custom-input-field"
                  type="text"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>

              <div className="mb-3">
                <label className="e-cuctsom-label-field">Contact Number</label>
                <input
                  className="e-custom-input-field"
                  type="number"
                  name="mobile"
                  value={formData.mobile || ""}
                  onChange={handleChange}
                />
              </div>

              <div className="mb-3">
                <label className="e-cuctsom-label-field">Class Upto</label>
                <input
                  className="e-custom-input-field"
                  type="number"
                  name="classUpto"
                  value={formData.classUpto || ""}
                  onChange={handleChange}
                />
              </div>

              <div className="mb-3">
                <label className="e-cuctsom-label-field">Board</label>
                <input
                  className="e-custom-input-field"
                  type="text"
                  name="board"
                  value={formData.board}
                  onChange={handleChange}
                />
              </div>

              <div className="mb-3">
                <label className="e-cuctsom-label-field">Medium</label>
                <input
                  className="e-custom-input-field"
                  type="text"
                  name="medium"
                  value={formData.medium}
                  onChange={handleChange}
                />
              </div>

              <div className="mb-3">
                <label className="e-cuctsom-label-field">
                  Number of Students
                </label>
                <input
                  className="e-custom-input-field"
                  type="number"
                  name="noStudents"
                  value={formData.noStudents || ""}
                  onChange={handleChange}
                />
              </div>

              <div className="mb-3">
                <label className="e-cuctsom-label-field-c">
                  <span>
                    Have you run Skill Development Programs for students?
                  </span>
                  <span className="mx-3">
                    <label className="me-2">
                      <input
                        className="e-custom-input-field-c"
                        type="radio"
                        name="anySkillProgram"
                        value="yes"
                        checked={formData.anySkillProgram === "yes"}
                        onChange={handleChange}
                      />
                      &nbsp; Yes
                    </label>
                    <label>
                      <input
                        className="e-custom-input-field-c"
                        type="radio"
                        name="anySkillProgram"
                        value="no"
                        checked={formData.anySkillProgram === "no"}
                        onChange={handleChange}
                      />
                      &nbsp; No
                    </label>
                  </span>
                </label>
              </div>
            </div>

            {formData.anySkillProgram === "yes" && (
              <div
                className="mb-3 e-cuctsom-label-field-c"
                style={{ marginLeft: "12%" }}
              >
                <label
                  style={{ textAlign: "left", fontSize: "18px" }}
                  htmlFor="skillProgramDetails"
                >
                  Enter Details
                </label>
                <br />
                <textarea
                  className="e-custom-textarea"
                  name="skillProgramDetails"
                  value={formData.skillProgramDetails}
                  onChange={handleChange}
                />
              </div>
            )}

            <div
              className="mb-3 e-cuctsom-label-field-c"
              style={{ marginLeft: "12%" }}
            >
              <label style={{ textAlign: "left", fontSize: "18px" }}>
                Choose the Skill Development Program/ Nature of Skill
                Development
              </label>
              <div>
                {categories.length > 0 &&
                  categories
                    ?.filter((cat) => cat.parent_id === 0) // main categories
                    .map((parent) => (
                      <div key={parent.id} className="mb-3">
                        {/* Parent Category */}
                        <label className="fw-bold d-block mb-2">
                          <input
                            type="checkbox"
                            className="me-2"
                            name="skillProgram"
                            value={parent.id}
                            checked={formData.skillProgramIds.includes(
                              parent.id
                            )}
                            onChange={(e) =>
                              dispatch(
                                setskillProgramIds(Number(e.target.value))
                              )
                            }
                          />
                          {parent.name}
                        </label>

                        {/* Show Sub Categories only if parent is checked */}
                        {formData.skillProgramIds.includes(parent.id) && (
                          <div
                            className="grid"
                            style={{
                              display: "grid",
                              gridTemplateColumns: "1fr 1fr", // 2 equal columns
                              gap: "10px",
                              marginLeft: "20px",
                            }}
                          >
                            {categories
                              .filter((sub) => sub.parent_id === parent.id)
                              .map((sub) => (
                                <label
                                  key={sub.id}
                                  className="d-flex align-items-center"
                                >
                                  <input
                                    type="checkbox"
                                    className="me-2"
                                    name="skillProgram"
                                    value={sub.id}
                                    checked={formData.skillProgramIds.includes(
                                      sub.id
                                    )}
                                    onChange={(e) =>
                                      dispatch(
                                        setskillProgramIds(
                                          Number(e.target.value)
                                        )
                                      )
                                    }
                                  />
                                  {sub.name}
                                </label>
                              ))}
                          </div>
                        )}
                      </div>
                    ))}
              </div>
            </div>
          </fieldset>
          <button className="btn btn-primary" type="submit">
            Submit
          </button>
        </form>
      </div>
    </>
  );
}

export default Eligibility;
